import { TestGroup } from './TestGroup';

export class TestAccession {
  LabNumber: string = "";
  ForeName: string="";
  Surname: string="";
  SourceId: number=0;
  SourceCode: string="";
  HospitalNo: string="";
  Reference: string="";
  Title: string="";
  Sex: string="";
  Dob: Date=new Date();
  AttendingDr: string="";
  SampleDate: Date = new Date();
  RequestDate: Date = new Date();
  ReportedDate: Date = new Date();
  Address1: string ="";
  Address2: string = "";
  Address3: string = "";
  PostCode: string = "";
  Tests: TestGroup[] =[];
}
